interface ObjectWithId extends Record<string, any> {
  id: string | number
}

interface ObjectWithItems<T extends ObjectWithId> extends Record<string, any> {
  items: T[]
}

const addItemToTop = <T extends ObjectWithId, U extends ObjectWithItems<T>>(prev: U, item: T): U => {
  if (!prev.items.some((it) => it.id === item.id)) {
    return { ...prev, items: [item, ...prev.items] }
  }

  return prev
}

const updateItem = <T extends ObjectWithId, U extends ObjectWithItems<T>>(prev: U, item: T): U => {
  const index = prev.items.findIndex((it) => it.id === item.id)
  if (index === -1) return prev

  return {
    ...prev,
    items: [...prev.items.slice(0, index), { ...prev[index], ...item }, ...prev.items.slice(index + 1)],
  }
}

const removeItem = <T extends ObjectWithId, U extends ObjectWithItems<T>>(prev: U, id: T['id']): U => {
  return { ...prev, items: prev.items.filter((it) => it.id !== id) }
}

const arrayUtils = { addItemToTop, updateItem, removeItem }
export default arrayUtils
